var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wettbewerbslogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{fill:#f2ac25;}.cls-4{clip-path:url(#clippath);}.cls-5{fill:#96234b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ENTEGA_Logo_RGB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10317",
    className: "cls-3",
    d: "M40,0C17.91,0,0,17.91,0,40s17.91,40,40,40,40-17.91,40-40C79.98,17.92,62.08.02,40,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Entega_Wei\\xDF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sternchen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10318",
    className: "cls-1",
    d: "M42.57,20.91l.74-5.01,6.84,1.08-1.22-6.77,5.08-.95,1.22,6.84,5.96-3.38,2.5,4.47-6.02,3.38,5.01,4.67-3.52,3.79-5.21-4.94-3.11,6.36-4.6-2.3,3.11-6.16-6.77-1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Entega_Wei\\xDF-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10319",
    className: "cls-5",
    d: "M15.03,54.42c1.37-.24,2.68-.75,3.86-1.49l-.81-2.44c-.97.59-2.05.98-3.18,1.15-2.1.34-3.25-.2-3.72-2.23l7.11-1.29c0-.5-.07-1-.2-1.49-.68-3.86-2.91-5.35-6.02-4.81-3.66.68-5.01,3.25-4.33,7.11.81,4.33,3.11,6.23,7.31,5.48ZM10.76,47.31c-.2-1.83.27-2.64,1.83-2.91,1.29-.2,2.23.34,2.57,2.1l-4.4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10320",
    className: "cls-5",
    d: "M31.47,51.3l-1.35-7.78c-.54-3.05-2.44-4.4-5.08-3.93-1.25.21-2.37.86-3.18,1.83l-.68-1.02-2.23.54,2.17,12.18,3.18-.54-1.56-8.8c.4-.7,1.1-1.18,1.9-1.29,1.29-.2,2.1.2,2.3,1.56l1.35,7.78,3.18-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10321",
    className: "cls-5",
    d: "M37.97,39.93l-.41-2.37-2.71.47-.47-2.91-2.44.68-.07,2.78-1.49.27.41,2.37,1.35-.27,1.15,6.36c.41,2.3,1.83,3.45,4.26,3.05.72-.11,1.41-.36,2.03-.74l-.61-2.23c-.3.16-.62.28-.95.34-.95.2-1.49-.07-1.69-1.02l-1.08-6.29,2.71-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10322",
    className: "cls-5",
    d: "M46.56,48.87c1.37-.24,2.68-.75,3.86-1.49l-.81-2.44c-.97.59-2.05.98-3.18,1.15-2.1.34-3.25-.2-3.72-2.23l7.11-1.29c0-.5-.07-1-.2-1.49-.68-3.86-2.91-5.35-6.02-4.81-3.66.68-5.01,3.25-4.33,7.11.81,4.33,3.05,6.23,7.31,5.48ZM42.3,41.76c-.2-1.83.27-2.64,1.83-2.91,1.29-.2,2.23.34,2.57,2.1l-4.4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10323",
    className: "cls-5",
    d: "M56.38,41.83c3.32-.61,4.4-2.17,3.99-4.53-.05-.45-.19-.89-.41-1.29l1.29-1.29-.88-1.35-2.1,1.08c-1.03-.32-2.13-.36-3.18-.14-3.38.61-4.4,2.37-3.99,4.6.12,1.13.81,2.13,1.83,2.64-.82.55-1.25,1.53-1.08,2.5.08.77.57,1.45,1.29,1.76-.52.59-.74,1.39-.61,2.17.34,1.83,2.03,2.98,5.55,2.37,3.99-.68,5.35-2.5,4.94-4.94-.34-1.9-1.83-2.57-4.47-2.23l-2.91.34c-.81.07-.95-.47-.95-.74-.04-.29.09-.58.34-.74.34-.07.81-.14,1.35-.2ZM55.5,36.48c1.29-.2,1.83.14,2.03,1.35s-.14,1.76-1.56,1.96c-.78.29-1.65-.11-1.94-.89-.05-.15-.09-.3-.09-.46-.2-1.15.2-1.76,1.56-1.96h0ZM58.34,45.68c1.42-.14,1.76.07,1.83.61.14.68-.34,1.22-2.64,1.62-1.62.27-2.3,0-2.44-.88-.05-.39.08-.79.34-1.08l2.91-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10324",
    className: "cls-5",
    d: "M71.13,44.26l2.44-.41-1.35-7.58c-.61-3.38-2.1-4.67-5.75-4.06-1.44.24-2.83.77-4.06,1.56l.68,2.44c.98-.65,2.09-1.08,3.25-1.29,1.69-.27,2.44.14,2.64,1.42l.14.68c-.81-.08-1.63-.05-2.44.07-2.78.47-4.13,2.3-3.72,4.6.47,2.78,2.37,3.59,4.47,3.18,1.26-.15,2.38-.88,3.05-1.96h.07l.61,1.35ZM69.78,40.68c.14.61-.74,1.42-1.83,1.62-1.02.2-1.83-.07-2.03-1.22-.14-.95.27-1.62,1.76-1.9.58-.12,1.17-.14,1.76-.07l.34,1.56Z"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.1c7650035ef60b0737c045fd8536b551.svg";